export default __webpack_public_path__ + "static/testimonial_bg-fbc5152e45a589865dbb57b965ee5fc2.jpg";